export const BY_ID = "ID";
export const BY_BALANCE = "FUNDS";

export const ASC = "ASC";
export const DESC = "DESC";
